import { ACTION_TYPES } from "./constants";

export const setLoadingAction = (loading: boolean) => ({
  type: ACTION_TYPES.SET_LOADING,
  payload: loading,
});
